
import { defineComponent, SetupContext, PropType } from "vue";
import { getApplianceCategoryWhiteIcon } from "@/utils/resource-util";
import { CommonRecipeFoodId } from "@/types/commonRecipe";
import CommonRecipeFoodIds from "@/components/commonRecipe/CommonRecipeFoodIds.vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "RecipeTopListItem",
  components: { CommonRecipeFoodIds },
  props: {
    /**
     * レシピ画像
     */
    recipeImageUrl: {
      type: String
    },
    /**
     * レシピ名
     */
    recipeLabel: {
      type: String,
      required: true
    },
    /**
     * レシピID
     */
    recipeId: {
      type: Number,
      required: true
    },
    /**
     * グループID
     */
    groupId: {
      type: Number,
      required: true
    },
    /**
     * レシピタイプ
     */
    recipeType: {
      type: String,
      required: true
    },
    /**
     * ApplianceCategory名
     */
    recipeApplianceCategory: {
      type: String,
      required: true
    },
    /**
     * ApplianceCategoryID
     */
    recipeApplianceCategoryId: {
      type: Number,
      required: true
    },
    recipeFoodIds: {
      type: Array as PropType<CommonRecipeFoodId[]>,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const onClick = () => {
      NativeClient.sendDebugLog("RecipeTopListItem onClick recipeId=" + props.recipeId + " recipeType=" + props.recipeType);
      context.emit('select-recipe', props.recipeId, props.recipeType);
    };
    const getReciptTitle = () => {
      return props.recipeLabel != null ? props.recipeLabel : "";
    };
    const getCategoryIcon = () => {
      let icon = null;
      if (props.recipeApplianceCategoryId != 0) {
        icon = getApplianceCategoryWhiteIcon(props.recipeApplianceCategoryId);
      }
      return icon;
    };
    const isShowCategory = () => {
      return props.recipeApplianceCategory != null && props.recipeApplianceCategory != "";
    };
    return {
      onClick,
      getReciptTitle,
      getCategoryIcon,
      isShowCategory,
    };
  }
});
